import React, { useState, useEffect } from 'react';
import { Spinner } from "react-bootstrap";
import { Modal, Button, Row, Col, Form, Table, Container } from 'react-bootstrap';
import POServices from '../../../services/PoServices';
import Swal from 'sweetalert2';
import RequestServies from '../../../services/RequestServies';
import UnitConversionService from "../../../services/UnitConversionService";


const PoViewModal = ({ show, handleClose, test, items }) => {
    const [suppliersLoaded, setSuppliersLoaded] = useState(false); // Add this at top level
    const [itemList, setItemList] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [itemsLoading, setItemsLoading] = useState(true);
    const [subject, setSubject] = useState('');
    const [submitLoading, setSubmitLoading] =
        useState(false);
    // =============================
    // 1. ADD THESE STATES AT TOP
    const [isAdvanceRental, setIsAdvanceRental] = useState(false);
    const [advanceRentalAmount, setAdvanceRentalAmount] = useState("");
    const [advanceRentalPercent, setAdvanceRentalPercent] = useState("");
    const [advanceRentalError, setAdvanceRentalError] = useState(false);
    const [reference, setReference] = useState('With reference to our discussion and negotiation, we wish to place the Purchase Order for the following items:');
    const [termConditionText, setTermConditionText] = useState(
        `1. Delivery:- 19.07.2025
2. Brand & Specification - The material will not be received or will be rejected in case the material brand/specification/length as per order are changed & MTC not provided.
3. Transportation - Freight Extra as per actual.
4. Refund / Replace - Should be of good quality and if not found satisfactory shall be returned back and replacement/refund to be provided by you within 3 days.
5. Invoice Submission - A) One Copy with Eway Bill sent to the Shipping address.
6. Invoice Submission - B) Original Invoice along with Ewaybill to be sent to our head office: 3rd floor, plot # 12/b, pocket 3, sec-17, Dwarka, New Delhi - 110075.
7. Payment Terms - 100% Advance.
8. Payment Terms - 30 Days PDC against date of delivery at site.
9. Payment Terms - 15 Days PDC after the delivery of material.
10. All concrete will be supplied as per the approved Design Mix and consistency checked at site by our client.
11. Weight bridge receipts are to be produced full and empty transit mixer at designated weight bridge centre (your cooperation as & when required for volume verification).
12. PRISM JOHNSON LIMITED will be responsible for the performance and strength of M-30.
13. All raw material like Cement OPC, Aggregate, Sand, Admixture will be of approved quality by us & our client and as per approved Mix Design. Royalty paid challan copies to be provided for compliance record keeping.
14. No escalation to be payable for any account. Rates are valid for 6 months project time.
15. Payment Terms - Payment will be released within 30 days after submission of 15 days bill with all documents duly approved by our site in-charge.
16. Material test certificate to be provided by you at the time of material delivery.
17. MTC of the cover block from manufacturer to be issued to us immediately along with delivery with signed and stamped copy.
18. Water Proofing (WPC) will be provided by Indigo.
19. Technical Specs to be maintained at site as below -
20. (A) SPAND content below or between 1% to 2%.
21. (B) pH adjustable between 9 - 10.
22. (C) Viscosity 140 to 150 sec (Hardness of water not more than 300 ppm) @ 0.1% dosage.
23. (D) Density range from 1.001 to 1.025.
24. Report - Please share daily basis polymer consumption report.
25. Consumption - You will provide guaranteed consumption of 0.400 gm/sqm. If polymer consumption exceeds 0.400 gm/sqm, you will have to bear extra consumption cost.
26. You will provide full-time technical staff on our site for a month (approx. cost will be ₹10,000/month).
27. Unloading - By Indigo Scope.
28. Weight Tolerance - 0.5% (+/-).
29. All manpower & support for fixing and removing of concrete pipeline to be done by you.
30. All work will be completed within 15 days as per site requirements.
31. The supply to be done in a continuous manner.
32. All raw material like Cement OPC, Aggregate, Sand, Admixture will be of approved quality by us & our client and as per approved Mix Design. Royalty paid challan copies to be provided for compliance record keeping.`
    );
    useEffect(() => {
        if (!show) {
            // 🔴 CLEAR OLD DATA WHEN MODAL CLOSES
            setItemList([]);
            setSelectedItems({});
            setItemsLoading(true);
            setSelectedSupplier(null);
        }
    }, [show]);

    const fetchModalItems = async () => {
        try {
            setItemsLoading(true);

            const res = await POServices.getPOItemsByRequestId(items?._id);

            const freshItems = res?.data || [];

            setItemList(freshItems);

        } catch (error) {
            console.error("Failed to refresh items", error);
        } finally {
            setItemsLoading(false);
        }
    };

    // items effect
    useEffect(() => {
        if (!show) return;

        setItemList([]);
        setSelectedItems({});
        setItemsLoading(true);

    }, [show]);

    useEffect(() => {
        if (!show || !items?._id) return;

        fetchModalItems();

    }, [show, items?._id]);

    // suppliers effect (separate)
    useEffect(() => {
        if (!suppliersLoaded) {
            fetchSuppliers();
            setSuppliersLoaded(true);
        }
    }, []);



    const fetchSuppliers = async () => {
        try {
            const res = await POServices.activeSuppliers();
            setSuppliers(res?.data || []);
        } catch (err) {
            console.error("Failed to fetch suppliers", err);
        }
    };

    const handleCheckboxChange = (index) => {
        setSelectedItems(prev => {

            const current = prev[index];

            // ✅ toggle only
            const isChecked = !current?.selected;

            // ❌ if unselect → remove directly (FAST)
            if (!isChecked) {
                const updated = { ...prev };
                delete updated[index];
                return updated;
            }

            // ✅ minimal object (NO heavy calculation)
            return {
                ...prev,
                [index]: {
                    selected: true,
                    foc: false,
                    rate: '',
                    supplier: selectedSupplier || '',
                    cgst: '',
                    sgst: '',
                    igst: '',
                    description: itemList[index]?.inventory?.masterItem?.description || '',
                    lockCGST: false,
                    lockSGST: false,
                    lockIGST: false,
                    invalid: false
                }
            };
        });
    };


    const handleFOCChange = (index) => {
        setSelectedItems(prev => {
            const currentItem = prev[index] || {};
            const isFOC = !currentItem.foc;

            return {
                ...prev,
                [index]: {
                    ...currentItem,
                    foc: isFOC,
                    rate: isFOC ? 0 : currentItem.rate || '',
                    cgst: isFOC ? 0 : currentItem.cgst || '',
                    sgst: isFOC ? 0 : currentItem.sgst || '',
                    igst: isFOC ? 0 : currentItem.igst || '',
                    lockCGST: isFOC,
                    lockSGST: isFOC,
                    lockIGST: isFOC,
                    invalid: false // ✅ ADD THIS
                }
            };
        });
    };


    const handleRateInput = (index, value) => {
        setSelectedItems(prev => {
            const currentItem = prev[index] || {};

            // ❌ BLOCK if FOC
            if (currentItem.foc) {
                return {
                    ...prev,
                    [index]: {
                        ...currentItem,
                        rate: 0
                    }
                };
            }

            return {
                ...prev,
                [index]: {
                    ...currentItem,
                    rate: value,
                    invalid: false
                }
            };
        });
    };


    const handleTaxInput = (index, field, value) => {
        setSelectedItems(prev => {
            const currentItem = prev[index] || {};

            // ❌ BLOCK if FOC
            if (currentItem.foc) {
                return {
                    ...prev,
                    [index]: {
                        ...currentItem,
                        cgst: 0,
                        sgst: 0,
                        igst: 0
                    }
                };
            }

            const parsedValue = parseFloat(value) || 0;

            let updated = {
                ...currentItem,
                [field]: parsedValue,
                lockCGST: false,
                lockSGST: false,
                lockIGST: false,
            };

            if (field === 'cgst') {
                updated = {
                    ...updated,
                    cgst: parsedValue,
                    sgst: parsedValue,
                    igst: 0,
                    lockSGST: true,
                    lockIGST: true,
                };
            } else if (field === 'igst') {
                updated = {
                    ...updated,
                    igst: parsedValue,
                    cgst: 0,
                    sgst: 0,
                    lockCGST: true,
                    lockSGST: true,
                };
            }

            return {
                ...prev,
                [index]: updated
            };
        });
    };



    const handleSupplierChange = (index, supplierId) => {
        setSelectedItems(prev => {
            const updatedItem = {
                ...(prev[index] || {}),
                supplier: supplierId,
                invalid: false,
            };

            return {
                ...prev,
                [index]: updatedItem,
            };
        });

        // Lock the selected supplier globally only on first selection
        setSelectedSupplier(supplierId); // always update global supplier
    };


    const handleRateBlur = (index) => {
        setSelectedItems(prev => {
            const current = prev[index] || {};

            // ✅ FOC FIX
            if (current.foc) {
                return {
                    ...prev,
                    [index]: {
                        ...current,
                        rate: 0,
                        invalid: false
                    }
                };
            }

            const rateNum = parseFloat(current.rate);

            const updated = {
                ...current,
                rate: !isNaN(rateNum) && rateNum > 0 ? rateNum.toFixed(2) : '',
                invalid: isNaN(rateNum) || rateNum <= 0
            };

            return {
                ...prev,
                [index]: updated
            };
        });
    };



    const handleSubmit = async () => {
        if (submitLoading) return;

        setSubmitLoading(true);

        try {
            const requisitionId = items?._id;

            if (!requisitionId) {
                Swal.fire({
                    icon: "warning",
                    title:
                        "Missing Requisition Data",
                    text:
                        "Requisition details are missing or invalid."
                });

                setSubmitLoading(false);
                return;
            }

            if (isAdvanceRental) {
                const amount =
                    parseFloat(
                        advanceRentalAmount
                    ) || 0;

                const percent =
                    parseFloat(
                        advanceRentalPercent
                    ) || 0;

                const total =
                    parseFloat(
                        calculatedTotal
                    ) || 0;

                if (
                    amount <= 0 ||
                    percent <= 0
                ) {
                    Swal.fire({
                        icon: "warning",
                        title:
                            "Advance Payment",
                        text:
                            "Please enter valid Amount or %."
                    });

                    setSubmitLoading(false);
                    return;
                }

                if (amount > total) {
                    Swal.fire({
                        icon: "warning",
                        title:
                            "Invalid Amount",
                        text:
                            "Advance amount cannot exceed total amount."
                    });

                    setSubmitLoading(false);
                    return;
                }

                if (percent > 100) {
                    Swal.fire({
                        icon: "warning",
                        title:
                            "Invalid Percentage",
                        text:
                            "Advance percentage cannot exceed 100%."
                    });

                    setSubmitLoading(false);
                    return;
                }
            }

            let hasInvalid = false;
            let subtotal = 0;
            let totalCgst = 0;
            let totalSgst = 0;
            let totalIgst = 0;

            const selectedData = [];
            let anyFOC = false;

            for (const [
                index,
                value
            ] of Object.entries(
                selectedItems
            )) {
                const rate = parseFloat(
                    value.rate
                );

                const supplier =
                    value.supplier;

                const isValid =
                    value.selected &&
                    (!isNaN(rate) &&
                        (rate > 0 ||
                            value.foc)) &&
                    supplier;

                if (!isValid) {
                    hasInvalid = true;
                    continue;
                }

                const item =
                    itemList[index];
                const master =
                    item?.inventory
                        ?.masterItem;

                const qty =
                    parseFloat(
                        item.approveQty
                    );

                const cgst =
                    parseFloat(
                        value.cgst
                    ) || 0;

                const sgst =
                    parseFloat(
                        value.sgst
                    ) || 0;

                const igst =
                    parseFloat(
                        value.igst
                    ) || 0;

                subtotal += rate * qty;
                totalCgst += cgst;
                totalSgst += sgst;
                totalIgst += igst;

                if (value.foc)
                    anyFOC = true;

                selectedData.push({
                    _id: item._id,

                    // Master Item
                    masterItem: master?._id,

                    // Part Details
                    partNo: master?.partNo || "",

                    description:
                        value.description ||
                        master?.description ||
                        "",

                    // Unit Details
                    unit:
                        master?.unit?.name || "",

                    unitId:
                        master?.unit?._id,

                    // Quantity
                    qtyRequired:
                        item.qtyRequired,

                    approveQty:
                        item.approveQty,

                    // Commercial
                    rate,
                    supplier,
                    cgst,
                    sgst,
                    igst,

                    // FOC
                    foc:
                        value.foc || false
                });
            }

            if (
                selectedData.length === 0 ||
                hasInvalid
            ) {
                Swal.fire({
                    icon: "warning",
                    title:
                        "Missing or Invalid Data",
                    text:
                        "Please fill all selected item details."
                });

                setSubmitLoading(false);
                return;
            }

            let poType = "Normal";

            if (anyFOC)
                poType = "FOC PO";

            if (isAdvanceRental)
                poType = "Advance Payment";

            const payload = {
                requisitionNo:
                    requisitionId,
                deliveryAddress:
                    items.storeAddress,
                items: selectedData,
                poType,
                totalAmount:
                    parseFloat(
                        (
                            subtotal +
                            totalCgst +
                            totalSgst +
                            totalIgst
                        ).toFixed(2)
                    ),
                totalCGSTAmount:
                    parseFloat(
                        totalCgst.toFixed(2)
                    ),
                totalSGSTAmount:
                    parseFloat(
                        totalSgst.toFixed(2)
                    ),
                totalIGSTAmount:
                    parseFloat(
                        totalIgst.toFixed(2)
                    ),
                totalItems:
                    selectedData.length,
                subject,
                reference,
                advanceRentalSelected:
                    isAdvanceRental,
                advanceRentalAmount:
                    isAdvanceRental
                        ? parseFloat(
                            advanceRentalAmount ||
                            0
                        )
                        : 0,
                advanceRentalPercent:
                    isAdvanceRental
                        ? parseFloat(
                            advanceRentalPercent ||
                            0
                        )
                        : 0,
                termCondition:
                    termConditionText
                        .split("\n")
                        .map((line) =>
                            line.trim()
                        )
                        .filter(
                            (line) =>
                                line.length > 0
                        )
            };

            await POServices.PurchaseOrder(
                payload
            );

            Swal.fire({
                icon: "success",
                title:
                    "Purchase Order Created",
                text: `${selectedData.length} item(s) submitted successfully.`,
                confirmButtonText: "OK"
            }).then(() => {
                test();
                handleClose();
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Failed",
                text:
                    error?.response?.data
                        ?.message ||
                    "Something went wrong."
            });
        } finally {
            setSubmitLoading(false);
        }
    };





    const selectedCount = Object.values(selectedItems).reduce((count, item) => (
        item.selected ? count + 1 : count
    ), 0);

    let totalBaseAmount = 0;
    let totalCGSTAmount = 0;
    let totalSGSTAmount = 0;
    let totalIGSTAmount = 0;

    for (const [index, item] of Object.entries(selectedItems)) {
        if (!item.selected || !item.rate || !itemList[index]?.approveQty) continue;

        const rate = parseFloat(item.rate) || 0;
        const qty = parseFloat(itemList[index].approveQty) || 0;
        const base = rate * qty;

        const cgst = base * ((parseFloat(item.cgst) || 0) / 100);
        const sgst = base * ((parseFloat(item.sgst) || 0) / 100);
        const igst = base * ((parseFloat(item.igst) || 0) / 100);

        totalBaseAmount += base;
        totalCGSTAmount += cgst;
        totalSGSTAmount += sgst;
        totalIGSTAmount += igst;
    }

    const calculatedTotal = (
        totalBaseAmount +
        totalCGSTAmount +
        totalSGSTAmount +
        totalIGSTAmount
    ).toFixed(2);
    const estimatedTotal = parseFloat(calculatedTotal) || 0;

    const handleQtyUpdate = async (item) => {
        const { value: newQty } = await Swal.fire({
            title: 'Update Approved Quantity',
            input: 'number',
            inputLabel: `Enter new approved quantity (current: ${item.approveQty})`,
            showCancelButton: true,
            inputAttributes: {
                step: 'any',
                min: '0'
            },
            inputValidator: (value) => {
                const num = parseFloat(value);

                if (!value || isNaN(num) || num <= 0) {
                    return 'Please enter a valid quantity greater than 0';
                }

                // 🔥 NEW VALIDATION
                if (num > item.approveQty) {
                    return `New quantity cannot be greater than current approved qty (${item.approveQty})`;
                }
            },
            didOpen: () => {
                const input = Swal.getInput();
                input?.removeAttribute('readonly');
                input?.focus();
            }
        });

        if (!newQty) return; // No update if user cancels

        try {
            const qty = parseFloat(newQty);

            await RequestServies.updateItemQty(item._id, { approveQty: qty });

            // ✅ refresh modal ONLY
            await fetchModalItems();

            Swal.fire({
                icon: 'success',
                title: 'Quantity Updated',
                text: `Approved quantity updated to ${qty}`,
                timer: 1200,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('❌ Update Failed:', error);
            Swal.fire({
                icon: 'error',
                title: 'Update Failed',
                text: error?.response?.data?.message || 'Something went wrong during update.'
            });
        }
    };
    const handleUnitClick = async (item) => {
        try {
            const masterPartId = item?.inventory?.masterItem?._id;
            const fromUnit = item?.inventory?.masterItem?.unit;
            const fromUnitId = fromUnit?._id;
            const partNo = item?.inventory?.masterItem?.partNo || "N/A";
            const approvedQty = item?.approveQty || 0;

            if (!masterPartId || !fromUnitId) {
                return Swal.fire({
                    icon: "warning",
                    title: "Missing Data",
                    text: "Cannot determine master part or unit for conversion check.",
                });
            }

            // 🧠 Call API to check conversion rule
            const res = await UnitConversionService.byPartAndUnit({
                masterPart: masterPartId,
                fromUnit: fromUnitId,
            });

            const conversions = res?.data?.data || res?.data || [];

            if (conversions.length === 1) {
                const conversion = conversions[0];
                const value = conversion.conversionValue || 0;
                const toUnit = conversion.toUnit?.name || "N/A";

                // ✅ Divide since converting smaller → larger unit (KG → TON)
                const totalConverted = parseFloat(approvedQty / value).toFixed(2);

                const result = await Swal.fire({
                    icon: "success",
                    title: "Eligible for Unit Conversion",
                    html: `
          <div style="text-align:left; line-height:1.6;">
            <strong>Part No:</strong> ${partNo}<br/>
            <strong>From Unit:</strong> ${fromUnit?.name || "N/A"}<br/>
            <strong>To Unit:</strong> ${toUnit}<br/>
            <strong>Conversion Value:</strong> ${value}<br/>
            <hr/>
            <strong>Calculation:</strong><br/>
            ${approvedQty} ÷ ${value} = <strong>${totalConverted}</strong> ${toUnit}
          </div>
        `,
                    showCancelButton: true,
                    confirmButtonText: "Submit",
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#aaa",
                });

                if (result.isConfirmed) {
                    // ✅ Update both approvedQty and displayed unit
                    setItemList((prevList) =>
                        prevList.map((i) =>
                            i._id === item._id
                                ? {
                                    ...i,
                                    approveQty: parseFloat(totalConverted),
                                    convertedFrom: fromUnit?._id,
                                    convertedTo: conversion.toUnit?._id,
                                    conversionValue: value,
                                    inventory: {
                                        ...i.inventory,
                                        masterItem: {
                                            ...i.inventory.masterItem,
                                            unit: {
                                                ...i.inventory.masterItem.unit,
                                                name: toUnit, // 👈 Update visible unit
                                                _id: conversion.toUnit?._id,
                                            },
                                        },
                                    },
                                }
                                : i
                        )
                    );

                    await Swal.fire({
                        icon: "success",
                        title: "Quantity & Unit Updated",
                        text: `Approved quantity updated to ${totalConverted} ${toUnit}.`,
                        timer: 1500,
                        showConfirmButton: false,
                    });
                }
            } else {
                Swal.fire({
                    icon: "info",
                    title: "Not Eligible",
                    text: `Part No ${partNo} is not eligible for unit conversion.`,
                });
            }
        } catch (error) {
            console.error("Conversion check failed:", error);
            Swal.fire({
                icon: "error",
                title: "Error Checking Conversion",
                text: error?.response?.data?.message || "Something went wrong.",
            });
        }
    };




    // Get requisition number safely
    const requisitionNumber = items?.requisitionNo || '';

    const handleAdvanceAmountChange = (value) => {
        setAdvanceRentalAmount(value);
        setAdvanceRentalError(false);

        const amount = parseFloat(value);

        if (!value || isNaN(amount) || estimatedTotal <= 0) {
            setAdvanceRentalPercent("");
            return;
        }

        const percent = ((amount / estimatedTotal) * 100).toFixed(2);
        setAdvanceRentalPercent(percent);
    };

    const handleAdvancePercentChange = (value) => {
        setAdvanceRentalPercent(value);
        setAdvanceRentalError(false);

        const percent = parseFloat(value);

        if (!value || isNaN(percent) || estimatedTotal <= 0) {
            setAdvanceRentalAmount("");
            return;
        }

        const amount = ((estimatedTotal * percent) / 100).toFixed(2);
        setAdvanceRentalAmount(amount);
    };
    return (
        <Modal className="fade" show={show} onHide={handleClose} enforceFocus={false} fullscreen>

            <Modal.Header closeButton>
                <Modal.Title><i className="fas fa-edit"></i> Items Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row className="mb-4 p-3 rounded border bg-white shadow-sm">
                        <Col xs={12} className="text-center mb-3">
                            <h5 className="text-primary fw-bold">
                                <i className="fas fa-map-marker-alt me-2"></i>Delivery Address
                            </h5>
                        </Col>
                        <Col xs={12} md={6}><div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize"><strong className='text-dark'>Store Name</strong><div className='text-dark'>{items?.store || 'N/A'}</div></div></Col>
                        <Col xs={12} md={6}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Requisition No</strong>
                                <div className='text-dark'>
                                    {items?.requisitionNo || 'N/A'}
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Street</strong>
                                <div className='text-dark'>{items?.storeAddress?.street || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>City</strong>
                                <div className='text-dark'>{items?.storeAddress?.city || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>State</strong>
                                <div className='text-dark'>{items?.storeAddress?.state || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Pincode</strong>
                                <div className='text-dark'>{items?.storeAddress?.pincode || 'N/A'}</div>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Country</strong>
                                <div className='text-dark'>{items?.storeAddress?.country || 'N/A'}</div>
                            </div>
                        </Col>

                        <Col xs={12} md={4}>
                            <div className="border p-3 bg-primary rounded mb-1 text-center text-capitalize">
                                <strong className='text-dark'>Total Items</strong>
                                <div className='text-dark'>{items?.itemCount || 0}</div>
                            </div>
                        </Col>

                    </Row>





                    <Row>
                        <Col md="12">
                            <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered table-striped" style={{ minWidth: '1400px' }}>

                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ minWidth: '30px' }}>S.No</th>
                                            <th style={{ minWidth: '30px' }}>Part No</th>
                                            <th style={{ minWidth: '150px' }}>Description</th>
                                            <th style={{ minWidth: '30px' }}>Unit</th>
                                            <th style={{ minWidth: '30px' }}>Req. Qty</th>
                                            <th style={{ minWidth: '120px' }}>Approved Qty</th>
                                            <th style={{ minWidth: '120px' }}>Current Qty</th>
                                            <th style={{ minWidth: '80px' }}>Select</th>
                                            <th style={{ minWidth: '80px' }}>FOC</th>
                                            <th style={{ minWidth: '150px' }}>Rate</th>
                                            <th style={{ minWidth: '100px' }}>CGST</th>
                                            <th style={{ minWidth: '100px' }}>SGST</th>
                                            <th style={{ minWidth: '100px' }}>IGST</th>
                                            <th style={{ minWidth: '200px' }}>Supplier</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {itemsLoading ? (
                                            <tr>
                                                <td colSpan="14" className="text-center">
                                                    <Spinner animation="border" />
                                                    <div className="mt-2">Loading items...</div>
                                                </td>
                                            </tr>
                                        ) : itemList.length > 0 ? (
                                            itemList.map((item, index) => {
                                                const selected = selectedItems[index]?.selected;
                                                const invalid = selectedItems[index]?.invalid;

                                                return (
                                                    <tr key={index} className={invalid ? 'table-danger' : ''}>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.inventory?.masterItem?.partNo || '-'}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={
                                                                    selectedItems[index]?.description ??
                                                                    item?.inventory?.masterItem?.description ??
                                                                    ''
                                                                }
                                                                readOnly={!selected}   // ✅ better than disabled
                                                                onChange={(e) => {
                                                                    setSelectedItems(prev => ({
                                                                        ...prev,
                                                                        [index]: {
                                                                            ...(prev[index] || {}),
                                                                            description: e.target.value
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>

                                                        <td
                                                            style={{ cursor: "pointer", color: "#007bff" }}
                                                            onClick={() => handleUnitClick(item)}
                                                        >
                                                            {item?.inventory?.masterItem?.unit?.name || '-'}
                                                        </td>

                                                        <td>{item?.qtyRequired}</td>

                                                        <td>
                                                            <span
                                                                style={{ cursor: "pointer", color: "blue" }}
                                                                onClick={() => handleQtyUpdate(item)}
                                                            >
                                                                {item?.approveQty}
                                                            </span>
                                                        </td>

                                                        <td>{item?.inventory?.currentStock}</td>

                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={selected || false}
                                                                onChange={() => handleCheckboxChange(index)}
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedItems[index]?.foc || false}
                                                                disabled={!selected}
                                                                onChange={() => handleFOCChange(index)}
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={selectedItems[index]?.rate || ''}
                                                                disabled={!selected || selectedItems[index]?.foc} // ✅ ADD THIS
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) =>
                                                                    handleRateInput(index, e.target.value)
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={selectedItems[index]?.cgst || ''}
                                                                disabled={
                                                                    !selected ||
                                                                    selectedItems[index]?.lockCGST ||
                                                                    selectedItems[index]?.foc // ✅ ADD THIS
                                                                }
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) =>
                                                                    handleTaxInput(index, 'cgst', e.target.value)
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={selectedItems[index]?.sgst || ''}
                                                                disabled={
                                                                    !selected ||
                                                                    selectedItems[index]?.lockSGST ||
                                                                    selectedItems[index]?.foc // ✅ ADD THIS
                                                                }
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) =>
                                                                    handleTaxInput(index, 'sgst', e.target.value)
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={selectedItems[index]?.igst || ''}
                                                                disabled={
                                                                    !selected ||
                                                                    selectedItems[index]?.lockIGST ||
                                                                    selectedItems[index]?.foc // ✅ ADD THIS
                                                                }
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) =>
                                                                    handleTaxInput(index, 'igst', e.target.value)
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <select
                                                                className="form-control"
                                                                value={selectedItems[index]?.supplier || ''}
                                                                disabled={!selected || selectedSupplier}
                                                                onChange={(e) =>
                                                                    handleSupplierChange(index, e.target.value)
                                                                }
                                                            >
                                                                <option value="">Select Supplier</option>
                                                                {selectedSupplier
                                                                    ? suppliers
                                                                        .filter(s => s._id === selectedSupplier)
                                                                        .map((sup) => (
                                                                            <option key={sup._id} value={sup._id}>
                                                                                {sup.address?.state ? `${sup.name} (${sup.address.state})` : sup.name}
                                                                            </option>
                                                                        ))
                                                                    : suppliers.map((sup) => (
                                                                        <option key={sup._id} value={sup._id}>
                                                                            {sup.address?.state ? `${sup.name} (${sup.address.state})` : sup.name}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            // ❌ NO DATA
                                            <tr>
                                                <td colSpan="14" className="text-center text-muted">
                                                    No items available.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={12}>
                            <div className="border rounded p-3 bg-light">

                                <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                                    <Form.Check
                                        type="checkbox"
                                        label={
                                            <span className="text-dark fw-bold">
                                                Advance Payment
                                            </span>
                                        }
                                        checked={isAdvanceRental}
                                        onChange={(e) => {
                                            const checked = e.target.checked;

                                            setIsAdvanceRental(checked);

                                            if (!checked) {
                                                setAdvanceRentalAmount("");
                                                setAdvanceRentalPercent("");
                                                setAdvanceRentalError(false);
                                            }
                                        }}
                                    />

                                    <strong className="text-dark">
                                        Estimated Total Amount : ₹{calculatedTotal}
                                    </strong>
                                </div>

                                {isAdvanceRental && (
                                    <Row className="align-items-end">

                                        {/* Amount */}
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label className="text-dark fw-bold">
                                                    Amount
                                                </Form.Label>

                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter Amount"
                                                    value={advanceRentalAmount}
                                                    onWheel={(e) => e.target.blur()}
                                                    onChange={(e) =>
                                                        handleAdvanceAmountChange(e.target.value)
                                                    }
                                                    isInvalid={advanceRentalError}
                                                />
                                            </Form.Group>
                                        </Col>

                                        {/* Percentage */}
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label className="text-dark fw-bold">
                                                    %
                                                </Form.Label>

                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter %"
                                                    value={advanceRentalPercent}
                                                    onWheel={(e) => e.target.blur()}
                                                    onChange={(e) =>
                                                        handleAdvancePercentChange(e.target.value)
                                                    }
                                                    isInvalid={advanceRentalError}
                                                />
                                            </Form.Group>
                                        </Col>

                                        {/* Info Text */}
                                        <Col md={4} className="d-flex align-items-center">
                                            <span className="text-dark fw-bold">
                                                Dynamic Calculation Enabled
                                            </span>
                                        </Col>

                                    </Row>
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-4 mt-3 pb-4 pt-3 rounded border bg-light shadow-sm">
                        <Col xs={12} className="text-center mb-3">
                            <h5 className="fw-bold"><i className="fas fa-info-circle me-2"></i>Additional PO Information</h5>
                        </Col>

                        <Col md={12}>
                            <Form.Group controlId="subject">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter subject"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12}>
                            <Form.Group controlId="reference">
                                <Form.Label>Reference</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Enter reference"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mt-3">
                            <Form.Group controlId="termCondition">
                                <Form.Label className='fw-bold'>Terms & Conditions (one per line)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Enter terms and conditions, one per line"
                                    value={termConditionText}
                                    onChange={(e) => setTermConditionText(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>



                    {selectedCount > 0 && (
                        <Row className="mt-3">
                            <Col className="text-end text-success fw-bold">
                                Total Selected Items: {selectedCount}<br />
                                Base Amount: ₹{totalBaseAmount.toFixed(2)}<br />
                                CGST: ₹{totalCGSTAmount.toFixed(2)} | SGST: ₹{totalSGSTAmount.toFixed(2)} | IGST: ₹{totalIGSTAmount.toFixed(2)}<br />
                                <span className="text-primary">Estimated Total Amount: ₹{calculatedTotal}</span>
                            </Col>

                        </Row>
                    )}
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    disabled={submitLoading}
                >
                    {submitLoading
                        ? "Please Wait..."
                        : "Close"}
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={
                        selectedCount === 0 ||
                        submitLoading
                    }
                >
                    {submitLoading
                        ? "Submitting..."
                        : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default React.memo(PoViewModal);
